// extracted by mini-css-extract-plugin
export var featured_card = "FeaturedCard-module--featured_card--6-g9H";
export var featured_card_thumbnail = "FeaturedCard-module--featured_card_thumbnail--h7O+e";
export var featured_card_header = "FeaturedCard-module--featured_card_header--duCS+";
export var featured_card_title = "FeaturedCard-module--featured_card_title--ius2z";
export var featured_card_date = "FeaturedCard-module--featured_card_date--mlNi2";
export var featured_card_icon = "FeaturedCard-module--featured_card_icon--8lq6h";